<script setup lang="ts">
/**
 * Seul point d'entrée des icônes. Trait de 1,5 et couleur héritée (`currentColor`) imposés :
 * aucune icône ne peut diverger. Décorative par défaut ; donner `label` si elle porte un sens seule.
 */
import { computed, h, type VNode } from 'vue'

import { icons, type IconName } from '../icons/registry'

const props = withDefaults(
  defineProps<{
    name: IconName
    size?: 16 | 20 | 24
    label?: string
  }>(),
  { size: 20, label: undefined },
)

const STROKE_WIDTH = 1.5

function kebab(attribute: string): string {
  return attribute.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)
}

const children = computed<VNode[]>(() =>
  icons[props.name].map(([tag, attributes]) => {
    const normalized: Record<string, string | number> = {}
    for (const [key, value] of Object.entries(attributes)) {
      if (key === 'key') continue
      normalized[kebab(key)] = key === 'strokeWidth' ? STROKE_WIDTH : value
    }
    return h(tag, normalized)
  }),
)

function Glyph() {
  return children.value
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    class="shrink-0"
    :role="label ? 'img' : undefined"
    :aria-label="label"
    :aria-hidden="label ? undefined : 'true'"
    focusable="false"
  >
    <Glyph />
  </svg>
</template>
